module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('cellphone')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.user.cellphone')
    },
    on: {
      "change": function($event) {
        _vm.errors.clear()
      }
    },
    model: {
      value: (_vm.mutableCellphone),
      callback: function($$v) {
        _vm.mutableCellphone = $$v
      },
      expression: "mutableCellphone"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('cellphone')))])], 1), _vm._v(" "), _c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('captcha')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.user.captcha')
    },
    on: {
      "change": function($event) {
        _vm.errors.clear()
      }
    },
    model: {
      value: (_vm.mutableCaptcha),
      callback: function($$v) {
        _vm.mutableCaptcha = $$v
      },
      expression: "mutableCaptcha"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('captcha')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "v-code-btn",
    attrs: {
      "disabled": _vm.sended
    },
    on: {
      "click": _vm.sendCaptcha
    }
  }, [_vm._v("\n        " + _vm._s(_vm.sended ? ("已发送（" + _vm.cooldown + "）") : '发送验证码') + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87878398"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/cellphone.input.vue
// module id = 936
// module chunks = 3